@if (!isLoadingAvailableViewColumns && !isLoadingCiTableHeader && !isFirstLoad) {
	<div class="cmdb-home-screen-container">
		<h1 class="title">{{ labels.lbl_cmdb }}</h1>
		<div class="header-options">
			<msp-breadcrumb-navigation
				[breadcrumb]="[
					{
						route: '/cmdb/list',
						label: labels.lbl_geral_inicio,
					},
					{
						route: '/cmdb/list',
						label: labels.lbl_asset_inventario,
					},
				]">
			</msp-breadcrumb-navigation>
			<div class="interactions-container">
				<div class="toggle-switch">
					<span>{{ labels['lbl_mostrar_inativos'] }}</span>
					<cpi-toggle-switch
						[invertToggle]="false"
						[switchOn]="showInactiveCis"
						(switchOnChange)="
							showInactiveCis = $event === true;
							recount = true;
							setLocalstorage('cmdbhpShowInactiveCis', $event === true);
							searchCITable(1)
						">
					</cpi-toggle-switch>
				</div>
				<div class="search-container">
					<input
						[placeholder]="labels.lbl_pesquisar_ci"
						(keyup)="setGeneralSearch($event)"
						title="{{ labels.lbl_geral_colunas_busca }}" />
					<button class="search-button" (click)="searchCITable(1)"><fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon></button>
				</div>
				<!-- <button (click)="clearAllSearchParams()">{{ labels.lbl_limpar_filtros }}</button> -->
				<button (click)="importCisModal.openModal()">{{ labels.lbl_geral_importar }}</button>
				<a [href]="'cmdb/new'" [ngClass]="{ 'disabled-by-permission': !PermissionService.hasPermission('cmdb_inserir') }"
					><button>
						<span>{{ labels.lbl_adicionar_ativo }}</span
						><span><fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon></span></button
				></a>
			</div>
		</div>

		@if (ciTableHeader?.length > 0) {
			<msp-table-rmk
				[headers]="ciTableHeader"
				[data]="ciTableData()"
				[enableSorting]="true"
				[sort]="tableSort"
				(getSort)="tableSort = $event; searchCITable(1)"
				[enableSearching]="true"
				(getSearch)="tableSearch[$event.id] = $event.values; recount = true; searchCITable(1)"
				(cleanSearch)="tableSearch = {}; recount = true; searchCITable(1)"
				[enableSelecting]="true"
				(getSelectedRow)="onSelectedRowsChange($event)"
				[enableContextMenu]="true"
				[selectContextMenuRow]="true"
				[contextMenuOptions]="cmdbContextMenu"
				(getContextMenuData)="openCMDBTableContextMenu()"
				[enableExport]="true"
				(exportTable)="selectedModal = 'exportCI'"
				[enableCustomizeHeaders]="true"
				[availableHeaders]="availableCiTableColumns"
				[defaultHeaders]="defaultCiTableColumns"
				(saveHeaders)="saveCmdbViewColumns($event)"
				[isLoading]="isLoadingCiTable">
			</msp-table-rmk>
		}
		@if (ciTableCount > 0) {
			<div class="pagination-container has-total">
				<span></span>
				<cpi-pagination-counter
					[arrayLength]="ciTableCount"
					[itemsPerPage]="itemsPerPage"
					[setCurrentPage]="ciTablePage"
					(getCurrentPage)="searchCITable($event)">
				</cpi-pagination-counter>
				<span>{{ labels.lbl_geral_registros }}: {{ ciTableArrCount }}</span>
			</div>
		}
	</div>
}

@if (selectedModal === 'editCI') {
	<div class="modal-background" (click)="closeModal($event)">
		<div class="modal-container">
			<div class="header">
				<span class="title">{{ labels.lbl_editar_selecionados }}</span>
				<button (click)="closeModal()"><fa-icon [icon]="icons.faTimes"></fa-icon></button>
			</div>
			<div class="body">
				<div class="field-container">
					<span>{{ labels.lbl_geral_campos }}</span>
					<span>{{ labels.lbl_novo_valor }}</span>
					<select
						(change)="
							editField && (editField.values = []);
							$event.target.value === undefined ? (editField = undefined) : (editField = cmdbFields[$event.target.value])
						">
						<option [value]="undefined">{{ labels.lbl_geral_selecione }}</option>
						@for (field of cmdbFields; let index = $index; track field) {
							<option [value]="index">{{ labels[field.label] }}</option>
						}
					</select>
					@if (editField === undefined) {
						<input disabled />
					}
					@if (editField !== undefined) {
						<cpi-generic-form-gen [setGenericForm]="[editField]" [labels]="labels" [hideTitle]="true"></cpi-generic-form-gen>
					}
					<!---
					<select (change)="editField.values[0] = $event.target.value" *ngIf="editField && editField.items?.length > 0">
						<option [value]="''">{{labels.lbl_geral_selecione}}</option>
						<option [value]="item.values[0]" *ngFor="let item of editField.items">{{labels[item.label] ? labels[item.label] : item.label}}</option>
					</select>
					<input type="date"  (change)="editField.values[0] = $event.target.value" (input)="editField.values[0] = $event.target.value" *ngIf="editField && editField.inputType == 'timestamp'">
					<input type="number" (input)="editField.values[0] = $event.target.value" *ngIf="editField && editField.inputType == 'integer'">
					<input type="text" (input)="editField.values[0] = $event.target.value" *ngIf="editField && editField.inputType == 'varchar'">
					<cpi-checkbox
					[value]="editField.values[0]"
					(oValue)="editField.values[0] = $event"
					[innerText]="editField.values[0] ? labels.lbl_geral_sim : labels.lbl_geral_nao"
					*ngIf="editField && editField.inputType == 'bit'">
					</cpi-checkbox>
					--->
				</div>
			</div>

			<div class="footer">
				<div class="button-container">
					<msp-button [disabled]="isUpdatingCiField" [loading]="isUpdatingCiField" (click)="updateSelectedCis($event)">
						{{ labels.lbl_geral_atualizar }}
					</msp-button>
				</div>
			</div>
		</div>
	</div>
}

@if (selectedModal === 'digitalTerm') {
	<div class="modal-background" (click)="closeModal($event)">
		<div class="modal-container">
			@if (!isLoadingDigitalTerm) {
				<div class="header">
					<div class="title">{{ labels.lbl_termo_digital }}</div>
					<button (click)="closeModal()"><fa-icon [icon]="icons.faTimes"></fa-icon></button>
				</div>

				<div class="body">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_usuario_responsavel }}</span>

						<cpi-input-with-autocomplete
							[availableOptions]="availableEnduserIAC"
							[minInputLength]="0"
							[disabled]="!isEditingTerm"
							[setValue]="cmdbDigitalTermPayload.user"
							(onValueChange)="cmdbDigitalTermPayload.user = $event">
						</cpi-input-with-autocomplete>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_status }}*</span>
						<select [(ngModel)]="cmdbDigitalTermPayload.statusCmdb" [disabled]="!isEditingTerm">
							<option [value]="''" disabled>{{ labels.lbl_geral_selecione }}</option>
							@for (status of availableStatus; track $index) {
								<option [value]="status.status">
									{{ status.status }}
								</option>
							}
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_localidade }}*</span>
						<select (change)="cmdbDigitalTermPayload.location = $event.target.value" [disabled]="!isEditingTerm">
							@for (location of availableLocation; track $index) {
								<option [value]="location.name" [selected]="location.name === cmdbDigitalTermPayload.location">
									{{ location.name }}
								</option>
							}
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_asset_numero_serie }}*</span>
						<input
							type="text"
							disabled
							[value]="cmdbDigitalTermPayload.serial_number"
							[title]="cmdbDigitalTermPayload.serial_number" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_checklist }}?*</span>
						<select [(ngModel)]="cmdbDigitalTermPayload.checklist" [disabled]="!isEditingTerm">
							<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
							<option value="1">{{ labels.lbl_geral_sim }}</option>
							<option value="0">{{ labels.lbl_geral_nao }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_devolucao_troca_equipamento }}?*</span>
						<select [(ngModel)]="cmdbDigitalTermPayload.return_or_exchange_equipment" [disabled]="!isEditingTerm">
							<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
							<option value="1">{{ labels.lbl_geral_sim }}</option>
							<option value="0">{{ labels.lbl_geral_nao }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_usuario_desligado }}?*</span>
						<select [(ngModel)]="cmdbDigitalTermPayload.user_disconnected" [disabled]="!isEditingTerm">
							<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
							<option value="1">{{ labels.lbl_geral_sim }}</option>
							<option value="0">{{ labels.lbl_geral_nao }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_usuario_terceiro }}?*</span>
						<select [(ngModel)]="cmdbDigitalTermPayload.third_party_user" [disabled]="!isEditingTerm">
							<option [value]="-1" disabled>{{ labels.lbl_geral_selecione }}</option>
							<option value="1">{{ labels.lbl_geral_sim }}</option>
							<option value="0">{{ labels.lbl_geral_nao }}</option>
						</select>
					</div>

					<div>
						@if (
							cmdbDigitalTermPayload.id === '' &&
							(cmdbDigitalTermPayload.signature === null || cmdbDigitalTermPayload.signature === '') &&
							!isEditingTerm
						) {
							<span class="tip">{{ labels.lbl_solicitacao_assinatura_nao_enviada }}</span>
						}
						@if (cmdbDigitalTermPayload.id !== '' && cmdbDigitalTermPayload.signature === '' && !isEditingTerm) {
							<span class="tip">{{ labels.lbl_solicitacao_assinatura_enviada }}</span>
						}
						@if (cmdbDigitalTermPayload.signature && cmdbDigitalTermPayload.signature !== '' && !isEditingTerm) {
							<div class="dotted-input-container">
								<span>{{ labels.lbl_termo_assinado }}</span>
								<span class="link" (click)="downloadDigitalTerm(cmdbDigitalTermPayload.file)">
									{{ labels.lbl_download_termo }}
								</span>
							</div>
						}
					</div>
				</div>

				<div class="footer">
					<div class="button-container">
						<button [disabled]="isUpdatingDigitalTerm" class="b2" (click)="isEditingTerm = !isEditingTerm">
							@if (isEditingTerm) {
								{{ labels.lbl_geral_cancelar }}
							} @else {
								{{ labels.lbl_geral_editar }}
							}
						</button>
						@if (isEditingTerm) {
							<msp-button [disabled]="isUpdatingDigitalTerm" [loading]="isUpdatingDigitalTerm" (click)="submitUpdate()">
								{{ labels.lbl_geral_salvar }}
							</msp-button>
						}
					</div>
				</div>
			}

			@if (isLoadingDigitalTerm) {
				<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
			}
		</div>
	</div>
}

@if (selectedModal === 'exportCI') {
	<div class="modal-background" (click)="closeModal($event)">
		<div class="modal-container">
			<div class="header">
				<span class="title">{{ labels.lbl_extracao_geral }}</span>
				<button (click)="closeModal()"><fa-icon [icon]="icons.faTimes"></fa-icon></button>
			</div>
			<div class="body">
				<span>{{ labels.lbl_essa_extracao_pode_levar_segundos.replace('§_seconds_§', '60') }}</span>
			</div>

			<div class="footer">
				<div class="button-container">
					<div class="button" (click)="exportCITable()">{{ labels.lbl_geral_exportar }}</div>
				</div>
			</div>
		</div>
	</div>
}

<cpi-modal
	[title]="labels.lbl_geral_importar + ' CIS'"
	[showFooter]="!isLoadingImportInfo"
	(onModalClose)="onCloseImportModal()"
	id="importCisModal"
	#importCisModal>
	<ng-container body>
		@if (!isLoadingImportInfo && importBodyFields.length > 0) {
			<div class="import-table" [ngStyle]="{ 'grid-template-columns': '3rem repeat(' + importHeaderFields.length + ', 1fr)' }">
				<div class="line header">
					<div class="cell"></div>
					@for (cell of importHeaderFields; track $index) {
						<div class="cell">{{ cell.label }}</div>
					}
				</div>
				@for (line of importBodyFields; let lineI = $index; track line) {
					<div class="line" [ngClass]="{ 'l-alert': line.alert.on === true }">
						<div class="cell" [title]="line.alert.tip ? line.alert.tip : ''">
							@if (line.loading === true) {
								<cpi-ring-loading-effect [size]="'1rem'" [color]="'var(--primary-color-1)'"> </cpi-ring-loading-effect>
							}
							@if (line.loading === false && line.alert.icon) {
								<fa-icon
									[ngStyle]="{ color: line.alert.color ? 'var(--' + line.alert.color + ')' : 'unset' }"
									[icon]="icons[line.alert.icon]">
								</fa-icon>
							}
						</div>
						@for (cell of importHeaderFields; let cellI = $index; track cell) {
							<div
								class="cell"
								[title]="importBodyFields[lineI]['cells'][cellI]?.alert_tip || line.alert.tip || ''"
								[ngStyle]="{
									'background-color': importBodyFields[lineI]['cells'][cellI].alert_color
										? 'var(--' + importBodyFields[lineI]['cells'][cellI].alert_color + ')'
										: null,
								}"
								[ngClass]="{ 'c-alert': importBodyFields[lineI]['cells'][cellI].alert }">
								{{ importBodyFields[lineI]['cells'][cellI] ? importBodyFields[lineI]['cells'][cellI].label : '' }}
							</div>
						}
					</div>
				}
			</div>
		}

		@if (!isLoadingImportInfo && importBodyFields.length === 0) {
			<div class="instruction-container">
				<span>{{ labels['lbl_cmdb_importacao_instrucao_01'] }}</span>
				<span>{{ labels['lbl_cmdb_importacao_instrucao_02'] }}</span>
				<span>{{ labels['lbl_cmdb_importacao_instrucao_03'] }}</span>
				<br />
				<span [innerHTML]="labels['lbl_geral_id_diferencia_atualizacao_criacao_ci']"></span>
			</div>
		}

		@if (isLoadingImportInfo) {
			<div class="loading-container">
				<cpi-svg-gears></cpi-svg-gears>
				<div>{{ labels.lbl_edocs_carregando }}!</div>
			</div>
		}
	</ng-container>
	<ng-container footer>
		@if (!isLoadingImportInfo && importBodyFields.length > 0) {
			<div class="count-container">
				<div class="counter">
					<span>{{ labels['lbl_novos_ativos'] }}</span>
					<span>{{ importNewCiCount }}</span>
				</div>
				<div class="counter">
					<span>{{ labels['lbl_ativos_atualizados'] }}</span>
					<span>{{ importUpdateCiCount }}</span>
				</div>
				<div class="counter">
					<span>{{ labels['lbl_linhas_com_erro'] }}</span>
					<span>{{ importErrorCiCount }}</span>
				</div>
			</div>
		}
		<div class="button-container">
			@if (runnedImport && finishedImport) {
				<button (click)="runnedImport = false; onCloseImportModal(); finishedImport = false">
					{{ labels.lbl_chat_limpar }}
				</button>
			}
			<button (click)="downloadImportTemplate()">{{ labels.lbl_geral_baixar_template }}</button>
			<div>
				<label class="button" for="importFile">{{ labels.lbl_geral_anexar_arquivo }}</label>
				<input type="file" accept=".xlsx" id="importFile" #importFile (change)="handleImportFile($event)" />
			</div>
			<div class="batch-attachment-action">
				<label
					class="button"
					[class.disabled]="!finishedImport || isLoadingImportAttachment || isImportingCis.length > 0 || !importedCmdbIds.length"
					[attr.for]="
						!finishedImport || isLoadingImportAttachment || isImportingCis.length > 0 || !importedCmdbIds.length
							? null
							: 'importAttachmentFile'
					">
					{{ labels['lbl_anexo_cis_importados'] ?? 'Anexo para os CIs importados' }}
				</label>
				<input
					type="file"
					id="importAttachmentFile"
					#importAttachmentFile
					(change)="handleImportAttachmentFile($event)"
					[disabled]="!finishedImport || isLoadingImportAttachment || isImportingCis.length > 0 || !importedCmdbIds.length" />
			</div>
			<button
				[disabled]="importBodyFields.length === 0 || isImportingCis.length > 0 || finishedImport"
				(click)="importCisFromExcel()">
				{{ labels.lbl_geral_importar }}
				@if (isImportingCis.length > 0) {
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
				}
			</button>
			@if (PermissionService.hasPermission('cmdb_enviar_termos_batch')) {
				<button
					[disabled]="!finishedImport || isImportingCis.length > 0 || !importedCmdbIds.length"
					(click)="sendBatchTermAfterImport()">
					{{ labels['lbl_enviar_termos_importados'] ?? 'Enviar termos digitais' }}
				</button>
			}
			@if (isLoadingImportAttachment || importAttachmentName) {
				<div class="import-attachment-status">
					@if (isLoadingImportAttachment) {
						<span class="tip">Convertendo anexo...</span>
					}
					@if (importAttachmentName) {
						<span class="selected-file">{{ importAttachmentName }}</span>
					}
				</div>
				<div class="import-attachment-status">
					@if (isLoadingImportAttachment) {
						<span class="tip">Convertendo anexo...</span>
					}
					@if (importAttachmentName) {
						<span class="selected-file">{{ importAttachmentName }}</span>
					}
				</div>
			}
			@if (finishedImport && importErrorCiCount > 0) {
				<button (click)="exportImportErrorsToExcel()">{{ labels.lbl_geral_exportar }} Erros</button>
			}
		</div>
	</ng-container>
</cpi-modal>

@if (isLoadingAvailableViewColumns || isLoadingCiTableHeader || (isLoadingCiTable && isFirstLoad)) {
	<div class="loading-container">
		<cpi-svg-gears></cpi-svg-gears>
		<div>{{ labels.lbl_edocs_carregando }}!</div>
	</div>
}

<ng-template #actionsTemplate let-data="data" let-index="index">
	@if (data) {
		<div class="table-action-container">
			<a [routerLink]="'/cmdb/' + data.id + '/read'" [queryParams]="cmdbListQueryParams">
				<span><fa-icon [icon]="icons.faEye"></fa-icon></span>
			</a>
			@if (data.status !== 'Deleted' && data.status_related !== 'Deleted') {
				<a
					[ngClass]="{
						'disabled-by-permission':
							!checkPermissionByTypeOnTable(index) && !PermissionService.hasPermission('cmdb_digital_term_logistic_operator'),
					}"
					[routerLink]="'/cmdb/' + data.id + '/edit'"
					[queryParams]="cmdbListQueryParams"
					><fa-icon [icon]="icons.faPencil"></fa-icon
				></a>
				<span
					[ngClass]="{
						'disabled-by-permission':
							!checkPermissionByTypeOnTable(index) && !PermissionService.hasPermission('cmdb_digital_term_logistic_operator'),
					}"
					(click)="confirmDelete.classList.contains('confirmClick') ? deleteCi(data.id) : confirmButton(confirmDelete, $event)"
					#confirmDelete>
					<fa-icon [icon]="icons.faTrash"></fa-icon>
				</span>
			}
		</div>
	}
</ng-template>
